import { FC, useState } from "react";
import { useSelector } from "react-redux";

import { ButtonContainer, Card, FancyButtonLink } from "shared/components";
import { MutedDarkText, MutedText } from "shared/styles";
import { Settings } from "shared/assets/icons";
import { Spacer } from "shared/layout";
import { copy } from "shared/assets";
import { IAPIState } from "shared/types";

import { DeleteBandModal, EditBandModal } from "Bands/containers";
import { getBandSummaryActions } from "Bands/utils";
import { useBandContext, usePermissionsContext } from "Bands/contexts";
import { dataMetaSelector } from "Bands/state";
import { BAND_ACTIONS } from "Bands/types";

const {
  bandProperties,
  bandSettings: { sidemenu, bandSettingsIds },
} = copy;

export const BandSummary: FC = () => {
  const { band } = useBandContext();

  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const { bandPermissions } = usePermissionsContext();

  const { api: deleteBandApi } = useSelector(
    dataMetaSelector(BAND_ACTIONS.deleteBand)
  );

  const bandActions = getBandSummaryActions({
    handleEdit: bandPermissions.EDIT ? () => setShowEditModal(true) : undefined,
    handleDelete: () => setShowDeleteModal(true),
  });

  if (!band && deleteBandApi?.status !== IAPIState.succeeded) return null;

  return (
    <Card id={bandSettingsIds.band} title={sidemenu.band} icon={Settings}>
      <Spacer size="s">
        <Spacer size="xxs" spaceDirection="horizontal" align="center">
          <MutedDarkText>{bandProperties.name.title}:</MutedDarkText>
          <MutedText>{band?.title}</MutedText>
        </Spacer>
        <ButtonContainer>
          {bandActions.map(
            ({ label, handleClick, icon, status, dataTestId }, index) => (
              <FancyButtonLink
                onClick={handleClick}
                status={status}
                icon={icon}
                data-testid={dataTestId}
                key={index}
              >
                {label}
              </FancyButtonLink>
            )
          )}
        </ButtonContainer>
      </Spacer>
      {showEditModal && (
        <EditBandModal handleClose={() => setShowEditModal(false)} />
      )}
      {showDeleteModal && (
        <DeleteBandModal handleClose={() => setShowDeleteModal(false)} />
      )}
    </Card>
  );
};
